import http, { createApi } from '@core/fetch'

export default {
  getList: createApi('/p/wedding/index.php/Admin/APICoupon/List'),

  getDetail: body =>
    http('/p/wedding/index.php/Admin/APICoupon/Detail', { body }),

  activation: body =>
    http.post('/p/wedding/index.php/Admin/APICoupon/Activation', { body }),

  edit: body =>
    http.post('/p/wedding/index.php/Admin/APICoupon/CreateCouponV1', {
      body,
      ignore: [null, undefined]
    }),
  getReceiveList: body =>
    http('/p/wedding/index.php/Admin/APIUserCoupon/list', { body }),
  contactApi: body =>
    http.post('/p/wedding/index.php/Admin/APIUserCoupon/view_new_customers', {
      body
    }),

  contrastCouponApi: body =>
    http('/p/wedding/index.php/Admin/APICoupon/ContrastCoupon', { body }),

  properties: () => http('/p/wedding/index.php/Home/APIManagers/properties')
}
